module.exports = __webpack_public_path__ + "img/brackets_left_layout_icon.c658c2ce.svg";